import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLightning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.20001 0H4.40001C4.00001 0 3.60001 0.3 3.40001 0.7L1.40001 7.7C1.20001 8.4 1.70001 9 2.30001 9H6.00001L4.50001 16L11.8 6.6C12.3 6 11.8 5 11 5H8.00001L9.10002 1.3C9.30001 0.6 8.80001 0 8.20001 0Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconLightning;
